import { FolderId } from '../file';
import { FCFormDataType } from '@modules/settings/SettingsPage/Components/FormsTab/FormFields/types';
import { CompactUserResponse, UserId } from '../account';
import { BaseResponse } from '../common';
import { ManagementFormTemplateResponse } from '../managementFormTemplate';

export type ManagementFormID = string;
export type CommentId = string;

export interface ManagementFormResponse extends BaseResponse {
  id: ManagementFormID;
  folderId: FolderId;
  name: string;
  fields: FCFormDataType[];
  values: string;
  user: CompactUserResponse;
  createdBy: CompactUserResponse;
  canEdit: boolean;
  canForward: boolean;
  canAction: boolean;
  isClosed: boolean;
  canApprove: boolean;
  status: FormForwardUserStatus;
  forwards: FormForwardUserResponse[];
  logs: ManagementFormLogResponse[];
  isForwarded: boolean;
  comments: ManagementFormCommentResponse[];
  chainUsers: CompactUserResponse[];
  parent?: ManagementFormTemplateResponse;
  hasTakenAction: boolean;
  canSeeComments: boolean;
  archived: boolean;
}

export interface CompactManagementFormResponse extends BaseResponse {
  id: ManagementFormID;
  name: string;
  user: CompactUserResponse;
  canEdit: boolean;
}

export interface FormForwardUserResponse {
  id: string;
  from: CompactUserResponse;
  to: CompactUserResponse;
  formId: ManagementFormID;
  comments: string;
  status: FormForwardUserStatus;
}

export enum FormForwardUserStatus {
  pending = 'pending',
  approved = 'approved',
  rejected = 'rejected',
  draft = 'draft',
}

export interface ManagementFormLogResponse extends BaseResponse {
  id: string;
  description: string;
  type: ManagementFormLogType;
}

export enum ManagementFormLogType {
  created = 'created',
  updated = 'updated',
  forwarded = 'forwarded',
  approved = 'approved',
  rejected = 'rejected',
}

export interface ManagementFormCommentResponse extends BaseResponse {
  id: CommentId;
  formId: ManagementFormID;
  comment: string;
  createdAt: number;
  userId: string;
  user: CompactUserResponse;
  isOwner: boolean;
}

export interface PostManagementFormCommentPayload {
  formId: ManagementFormID;
  comment: string;
  user: UserId[];
  sendEmail: boolean;
}

export enum FormForwardType {
  send = 'send',
  approval = 'approval',
}

export interface FetchManagementFormRequest {
  status?: 'archived' | 'unarchived';
}
